import { putApi } from "./api_instance";

export const requestRecall = async (formData, dispatch) => {
  try {
    return await putApi({
      apiUrl: `/projects/api/request/recall-request`,
      sendToken: true,
      data: formData,
      dispatch,
    });
  } catch (error) {
    throw error;
  }
};
